<!-- Hero Section -->
<div class="solution-hero" *ngIf="solutionData">
    <div class="hero-overlay" style="filter: brightness(0.7);"
        [style.backgroundImage]="solutionData.heroImage ? 'url(' + solutionData.heroImage + ')' : null"></div>
    <div class="hero-content">
        <div class="solution-icon">
            <mat-icon>{{ solutionData.icon }}</mat-icon>
        </div>
        <h1 class="solution-title">{{ solutionData.title }} Solutions</h1>
    </div>
</div>

<!-- Main Content -->
<section class="solution-content" *ngIf="solutionData">
    <div class="container">

        <!-- Problem Section -->
        <div class="content-section problem-section">
            <div class="section-header">
                <mat-icon class="section-icon">error_outline</mat-icon>
                <h2>The Problem</h2>
            </div>
            <p class="section-text">{{ solutionData.problem }}</p>
        </div>

        <!-- Solution Section -->
        <div class="content-section solution-section">
            <div class="section-header">
                <mat-icon class="section-icon">lightbulb</mat-icon>
                <h2>Solutions</h2>
            </div>
            <p class="section-text">{{ solutionData.solution }}</p>
        </div>

        <!-- Recommended Bundle Section -->
        <div class="content-section bundle-section">
            <div class="section-header">
                <mat-icon class="section-icon">inventory_2</mat-icon>
                <h2>Recommended Bundle</h2>
            </div>

            <div class="bundle-grid">
                <div class="bundle-card" *ngFor="let bundle of solutionData.bundles">
                    <div class="bundle-icon-wrapper">
                        <mat-icon>{{ bundle.icon }}</mat-icon>
                    </div>
                    <h4 class="bundle-title">{{ bundle.title }}</h4>
                    <div class="bundle-checkmark">
                        <mat-icon>check_circle</mat-icon>
                    </div>
                </div>
            </div>
        </div>

        <!-- CTA Section -->
        <div class="cta-section">
            <a [routerLink]="solutionData.ctaLink" class="cta-button">
                <span>{{ solutionData.ctaText }}</span>
                <mat-icon>arrow_forward</mat-icon>
            </a>
        </div>

        <!-- Back to Solutions -->
        <div class="back-link-section">
            <a routerLink="/solutions" class="back-link">
                <mat-icon>arrow_back</mat-icon>
                <span>View All Solutions</span>
            </a>
        </div>

    </div>
</section>